export default "__VITE_ASSET__BjL40inartz73Fk6ZI3xKg__"